// 信用卡类型 正则校验
export function getCardTypeReg(value) {
  // Visa: length 16, prefix 4, dashes optional.
  // Mastercard: length 16, prefix 51-55, dashes optional.
  // Jcb: length 16
  const re = {
    reVisa: /^4\d{15}$/,
    reMc: /^5[1-5]\d{14}$/,
    reJcb1: /^1800\d{12}$/,
    reJcb2: /^2131\d{12}$/,
    reJcb3: /^3[0-9][0-9]\d{13}$/,
  }
  let newValue = null
  for(let i in re) {
    if (re[i].test(value)) {
      newValue = i
    }
  }
  return newValue
}